import React, { memo, useContext } from 'react'

import { Avatar } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, shape, string } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import ThreeDStudioPageContext from 'Pods/ThreeDStudio/ThreeDStudioPageContext'

const DATE_FORMAT = { year: 'numeric', month: 'short', day: 'numeric' }

// Holds the row's height while the author loads, so the prompt below does not jump up and back.
const placeholder = (
  <div className="image-gallery-modal__creator" aria-hidden="true">
    <span className="image-gallery-modal__creator-placeholder image-gallery-modal__creator-placeholder--avatar" />
    <div className="image-gallery-modal__creator-text">
      <span className="image-gallery-modal__creator-placeholder image-gallery-modal__creator-placeholder--name" />
      <span className="image-gallery-modal__creator-placeholder image-gallery-modal__creator-placeholder--date" />
    </div>
  </div>
)

function Creator({ user = null, createdAt = '', isLoading = false }) {
  const t = useTranslation()
  const { locale } = useContext(ThreeDStudioPageContext)

  if (isLoading) return placeholder
  if (!user?.username) return null

  const formattedDate = createdAt
    ? new Date(createdAt).toLocaleDateString(locale, DATE_FORMAT)
    : ''

  return (
    <div className="image-gallery-modal__creator">
      <Avatar
        className="image-gallery-modal__avatar"
        size="40"
        img={user.avatar_url || ''}
        username={user.username}
        useSingleLetter
      />
      <div className="image-gallery-modal__creator-text">
        <span className="image-gallery-modal__creator-name cgt-body-base-semibold">
          {t('imageGallery.modal.createdBy', { username: user.username })}
        </span>
        {formattedDate && (
          <time className="image-gallery-modal__creator-date cgt-caption" dateTime={createdAt}>
            {formattedDate}
          </time>
        )}
      </div>
    </div>
  )
}

Creator.propTypes = {
  user: shape({ username: string, avatar_url: string }),
  createdAt: string,
  isLoading: bool,
}

export default memo(Creator)
